export class FiltroCampoModel {
    tipoCadastro: number;
    nomeCampoFiltro: string;
    valorBusca: string;
    idRegistroDependente: string;

    constructor(tipoCadastro: number, nomeCampoFiltro: string = null, valorBusca: string = null, idRegistroDependente: string = null) {
        this.nomeCampoFiltro = nomeCampoFiltro;
        this.valorBusca = valorBusca;
        this.tipoCadastro = tipoCadastro;
        this.idRegistroDependente = idRegistroDependente;
    }
}
